import { render, staticRenderFns } from "./InspectDeviceDeal.vue?vue&type=template&id=10c6a251&scoped=true&"
import script from "./InspectDeviceDeal.vue?vue&type=script&lang=js&"
export * from "./InspectDeviceDeal.vue?vue&type=script&lang=js&"
import style0 from "./InspectDeviceDeal.vue?vue&type=style&index=0&id=10c6a251&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c6a251",
  null
  
)

export default component.exports